import React from 'react';
import PropTypes from 'prop-types';
import KpiSummary from '../../../commons/KpiSummary';

const StudentChurnSummary = (props) => (
  <KpiSummary
    title="CHURN"
    isLoading={props.isLoading}
    currentValue={props.currentValue}
    previousValue={props.previousValue}
    standardDeviationValue={props.standardDeviationValue}
    formatter={props.formatter}
  />
);

StudentChurnSummary.propTypes = {
  isLoading: PropTypes.bool,
  currentValue: PropTypes.string.isRequired,
  previousValue: PropTypes.string.isRequired,
  formatter: PropTypes.func.isRequired,
};

StudentChurnSummary.defaultProps = {
  isLoading: false,
};

export default StudentChurnSummary;
